import Icon from '../icon/Icon'
import { useRenterStreak } from '../../_hooks/use-renter-streak'
import { streakGlyphFor, streakLabelFor } from './helpers'
import { Pill, Glyph, Hint } from './styled'
import { StreakPillProps } from './types'

/**
 * Top-of-dashboard streak indicator. Records the renter's visit on
 * mount and shows a warm gradient pill with the current streak.
 *
 * @param {StreakPillProps} props
 * @returns {JSX.Element | null}
 */
const StreakPill = ({
  shouldShow = true,
}: StreakPillProps): JSX.Element | null => {
  const streak = useRenterStreak()

  if (shouldShow === false) {
    return null
  }

  if (streak === null) {
    return null
  }

  const glyph = streakGlyphFor(streak.currentStreakDays)
  const label = streakLabelFor(streak.currentStreakDays)

  const longestHint =
    streak.longestStreakDays > streak.currentStreakDays
      ? `· best ${streak.longestStreakDays}`
      : null

  return (
    <Pill aria-label={`${label}${longestHint ?? ''}`}>
      <Glyph aria-hidden="true">
        <Icon icon={glyph} />
      </Glyph>
      {label}
      {longestHint !== null ? <Hint>{longestHint}</Hint> : null}
    </Pill>
  )
}

export default StreakPill
